{
  "localeInternationalCountryCode": "PL",
  "PhoneInput": {
    "placeholder": "Wprowadź numer telefonu",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "Wybierz kraj",
    "emptyCountries": "Nie znaleziono krajów",
    "emptyDisplay": "-",
    "groupCommon": "Popularne",
    "groupAllCountries": "Wszystkie kraje"
  },
  "VersionSwitch": {
    "ariaLabel": "Wersja",
    "beta": "Beta",
    "new": "Nowa",
    "classic": "Klasyczna",
    "switchBackAnytime": "Możesz wrócić w każdej chwili",
    "sendFeedback": "Wyślij opinię",
    "feedbackDraft": "{{feature}} – uwagi:",
    "switchedToNew": "Przełączono na nową wersję",
    "switchedToClassic": "Przełączono na klasyczną wersję",
    "undo": "Cofnij"
  }
}
